import styled from 'styled-components';
import { cssScreens, colourPalette } from 'styles/styles';

export const LeftPanelPageBaseLeftComponentStyle = {
  Container: styled.div`
    flex: 1;
    background: ${colourPalette.blue600};
    display: flex;
    flex-direction: column;
    @media screen and (max-width: ${cssScreens.mobileLarge}) {
      display: none;
    }
  `,
  Content: styled.div`
    flex: 1;
    position: relative;
    padding: 72px 40px;
  `,
  ContentScroll: styled.div`
    position: absolute;
    inset: 0;
  `,
  Scroll: styled.div`
    overflow-y: overlay;
    height: 100%;
    max-height: 100%;
    @media screen and (min-height: 672px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    ::-webkit-scrollbar {
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
  `,
  Items: styled.div`
    max-width: 500px;
    margin: 72px auto;
    padding: 0 40px;
    @media screen and (min-height: 672px) {
      margin: 72px auto 32px auto;
    }
  `,
  BlackSection: styled.div`
    height: 50px;
    width: 100%;
    background: ${colourPalette.neutral900};
  `,
};
